import React from "react";
import { useEffect, useState } from "react";
import Tab from "./Tab/Tab";
import Panel from "./Panel/Panel";
import TabBar from "./TabBar/TabBar";
import TabContext from "./TabContext";
import { noop, wrapper } from "../types";
const defaultProps = {
  ...wrapper,
  tabChangeCallback: noop
};
const Tabs = ({
  children,
  className,
  startingTab,
  tabChangeCallback
}) => {
  const [activeTab, setActiveTab] = useState(startingTab);
  const classes = ["tabs", className].filter(Boolean).join(" ");
  useEffect(() => {
    if (tabChangeCallback)
      tabChangeCallback(activeTab);
  }, [activeTab]);
  return /* @__PURE__ */ React.createElement(TabContext.Provider, {
    value: { setActiveTab, activeTab }
  }, /* @__PURE__ */ React.createElement("section", {
    className: classes
  }, children));
};
Tabs.defaultProps = defaultProps;
Tabs.Tab = Tab;
Tabs.Panel = Panel;
Tabs.TabBar = TabBar;
Tabs.Toggle = () => null;
export default Tabs;
